export default {
    bind(el, binding, vnode) {
        const defaultValue = el.value;

        el.addEventListener('change', event => {
            if (binding.modifiers.newtab) {
                window.open(event.target.value, '_blank').focus();
            } else {
                window.location = event.target.value;
            }

            if (binding.modifiers.revert) {
                el.value = defaultValue;
            }
        }, { passive: true });
    }
}
